import { render } from "./CreateUser.vue?vue&type=template&id=c742ba8a"
import script from "./CreateUser.vue?vue&type=script&lang=js"
export * from "./CreateUser.vue?vue&type=script&lang=js"

import exportComponent from "/Users/souban/Documents/Code/Amaze-Portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__